import { renderClassName } from "@/utils/renderClassName";

export type ElementType =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "li"
  | "strong";
export type ElementStyleType =
  | "h1"
  | "h2"
  | "h2-secondary"
  | "subtitle"
  | "subtitle-secondary"
  | "body"
  | "body-secondary";
export type FontFamilyType = "overpass" | "noto-serif";

type TextProps = {
  children: React.ReactNode;
  element: ElementType;
  elementStyle: ElementStyleType;
  className?: string;
  fontFamily?: FontFamilyType;
};

const Text = ({
  element,
  elementStyle,
  className,
  fontFamily,
  children,
}: TextProps) => {
  const Element = element;
  return (
    <Element
      className={renderClassName(elementStyle as string, className)
        .concat(fontFamily ? ` ${fontFamily}` : "")
        .trim()}
    >
      {children}
    </Element>
  );
};

export default Text;
